import { HANDLE_SIDEBAR } from './index'

export const handleSidebarAction: Types.ActionFactory<string> = (payload?) => ({
  type: HANDLE_SIDEBAR,
  payload,
})
